export default "__VITE_ASSET__D4zW3oc9__"